<template>
  <div class="notes publick">
    <div class="notesLeft fl">
      <li v-for="(item, index) in Notes.data" :key="index">
        <div class="img fl"><img :src="item.avatar" width="65" height="65" alt=""></div>
        <div class="Txt fr">
          <div class="name">
            <span class="fl">{{item.username}} <span style="font-size: 14px;" >{{item.name}}</span> </span>
            <span class="fr">{{item.create_time}}</span>
          </div>
          <div class="p">{{item.content}}</div>
        </div>
      </li>
    </div>
    <div class="detRight fr">
      <detRight :pushcourse="pushcourse" :lecturer="lecturer"></detRight>
    </div>

    <div style="clear: both;"></div>
    <div class="page publick">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="Notes.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import detRight from '@/components/CourseDetails/detRight/detRight'

  export default {
    components: {
      detRight
    },
    data () {
      return {
        page: 1,
        lecturer: [],
        pushcourse: [],
        id: '',
        Notes: {}
      }
    },
    created () {
      this.lecturer = this.$parent.info.lecturer
      this.pushcourse = this.$parent.pushcourse
      this.id = this.$parent.id
      this.getNotes()
    },
    methods: {
      pageChange (page) {
        this.page = page
        this.getNotes()
      },
      getNotes () {
        this.$http.post('/apipx/Course/notes', {
          px_course_id: this.id,
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.Notes = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .notes {
    color: #535353;
    margin-bottom: 100px !important;
    overflow: hidden;
    width: 1200px !important;

    .notesLeft {
      margin-top: 40px;
      width: 700px;
      padding: 35px;
      box-shadow: 0px 0px 35px #f8f8f8;
      border-radius: 20px;
      overflow: hidden;

      li {
        overflow: hidden;
        margin-top: 35px;

        &:first-child {
          margin: 0;
        }

        .img {
          width: 85px;
          height: 85px;

          img {
            border-radius: 50%;
            overflow: hidden;
          }
        }

        .Txt {
          width: 615px;

          .name {
            line-height: 25px;
            margin: 20px auto 0;
            width: 100%;
            height: 25px;
            overflow: hidden;

            .fl {
              font-size: 22px;
            }

            .fr {
              font-size: 14px;
              color: #b3b3b3;
            }
          }

          .p {
            font-size: 14px;
            margin: 10px auto 0;
            line-height: 30px;
          }
        }
      }
    }

    .notesRight {
      width: 400px;
      margin-top: 40px;

      .teacher {
        width: 400px;
        box-shadow: 0px 0px 35px #f8f8f8;
        border-radius: 20px;
        position: relative;
        padding-bottom: 40px;

        .img {
          width: 80px;
          height: 80px;
          position: absolute;
          left: 160px;
          top: -40px;
          background-color: #fff;
        }

        .name {
          font-size: 26px;
          text-align: center;
          padding-top: 60px;
        }

        .dec {
          font-size: 12px;
          color: #6f6f6f;
          text-align: center;
          margin: 10px auto 0;
        }

        .p {
          line-height: 40px;
          padding: 0 35px;
          margin: 30px auto 0;
        }
      }

      .recommended {
        .tit {
          font-size: 18px;
          color: #5c5c5c;
          font-weight: bold;
          margin: 40px auto 0;
        }
      }

      ul {
        li {
          height: 95px;
          width: 400px;
          margin: 20px 0 0 0;

          .img {
            height: 95px;
            width: 135px;
            border-radius: 5px;
          }

          .Txt {
            width: 240px;
            height: 95px;
            border-bottom: 1px solid #ebebeb;

            h5 {
              font-size: 16px;
              margin-top: 20px;
            }

            .num {
              height: 20px;
              width: 100%;
              font-size: 12px;
              color: #8f8f8f;
              margin-top: 10px;

              img {
                display: block;
                float: left;
              }

              .people {
                line-height: 20px;
                margin-right: 20px;

                img {
                  margin: 3px 5px 0 0;
                }
              }

              .comment {
                line-height: 20px;

                img {
                  margin: 5px 5px 0 0;
                }
              }
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto 0;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/notes/notes.vue